import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://api.justreview.co',
});

export default instance;